export const breakpoints = {
  xs: 0,
  sm: 733,
  md: 1024,
  lg: 1920,
} as const;
